import script from "./ListCandidats.vue?vue&type=script&setup=true&lang=js"
export * from "./ListCandidats.vue?vue&type=script&setup=true&lang=js"

import "./ListCandidats.vue?vue&type=style&index=0&id=65b6d2c1&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-65b6d2c1"]])

export default __exports__